import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import cookie from "js-cookie";
import { useRouter } from "next/router";
import Slider from "react-slick";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import axios from "axios";
import config from "../../../config";
import Head from "next/head";
function BedroomDesigns() {
  const [selectedImage, setSelectedImage] = useState(null);
  const [show, setShow] = useState(false);
  const [isReadMore, setIsReadMore] = useState(false);
  const submitGetInTouch = async () => {
    const namee = touch.name;
    const no = touch.number;
    const pin = touch.pincode;

    if (!namee || !no || !pin) {
      setTouch({
        ...touch,
        error: "All fields are required",
      });
    } else if (String(pin).length != 6) {
      setTouch({
        ...touch,
        error: "Invalid Pincode",
      });
    } else {
      setTouch({
        ...touch,
        error: "",
        loading: true,
      });
      let response = await getIntouch({
        name: namee,
        phone: no,
        pincode: pin,
      });
      if (response?.message) {
        localStorage.setItem("leadfilled", true);
        swal(response?.message);
        setTouch({
          ...touch,
          error: "",
          loading: false,
        });
      } else {
        swal(response.data.get_in_touch.msg);
        // setGetInTouch(false)

        setTouch({
          name: "",
          number: "",
          error: "",
          loading: false,
        });
        setIsExpertTalkClicked(false);
      }
    }
  };
  const settings = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    centerMode: false,
    autoplaySpeed: 3000,
    arrows: true,
    dots: false,
    centerPadding: "0px",
    responsive: [
      {
        breakpoint: 991,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 641,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 1,
        },
      },
    ],
  };

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  const settings2 = {
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    centerMode: false,
    autoplaySpeed: 3000,
    arrows: true,
    dots: false,
    centerPadding: "0px",
    responsive: [
      {
        breakpoint: 991,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 641,
        settings: {
          arrows: true,
          centerMode: false,
          slidesToShow: 1,
        },
      },
    ],
  };
  const [activeIndex, setActiveIndex] = useState(null);
  const router = useRouter();
  const [isExpertTalkClicked, setIsExpertTalkClicked] = useState(false);
  const [relatedBlogData, setRelatedBlogData] = useState([]);
  const [touch, setTouch] = useState({
    name: "",
    number: "",
    pincode: cookie.get("pincode"),
    error: "",
    loading: false,
  });

  useEffect(() => {
    getRelatedBlogs();
  }, []);

  const faqs = [
    {
      question: "How do I get the right bedroom layout for my space?",
      answer:
        "For the right bedroom layout, consider your bedroom's dimensions and shape. Start by placing essential furniture, like the bed, in a central position. Ensure there’s ample space for movement and practical access to storage areas. Experiment with the placement of your furniture on the floor space to visualize and optimize the layout.",
    },
    {
      question: "What are some popular bedroom design styles?",
      answer:
        "Popular bedroom styles include the modern style that features clean lines, neutral shades of tiles, and simple decor. Then we have classics featuring elegant furniture and rich colours. There's also rustic, which comes with old wooden finish materials and grey or black tiles. And then there's coastal, which uses light colours, wooden tiles, and beach-inspired decor.",
    },
    {
      question: "What lighting options are best for bedrooms?",
      answer:
        "Use various lighting to light up different parts of your bedroom. You can go ahead with overhead lights or install a ceiling fan with light for general lighting. Besides that, bedside lamps, LED strips, or wall sconces can be used to add style and extra light.",
    },
    {
      question: "How do I choose the right colour scheme for my bedroom?",
      answer:
        "Colour schemes help establish the atmosphere you want in your bedroom. Shades like beige and grey help set the tone of relaxation, while bold ones like blue and green create a statement and vibrancy.",
    },
    {
      question: "What are the latest trends in bedroom design?",
      answer:
        "Bedroom designs in trend incorporate elements like plants and wooden furniture. Textured wall tiles for visual interest and multifunctional furniture to conserve space have also been popular. Additionally, warm-toned tiles for both walls and floors are also popular for a cosy and inviting look.",
    },
  ];

  const text = ` More than just the four walls, a bedroom is where your day begins and ends, where your dreams take shape, and where you find comfort after that long, busy day. This makes it important to build a bedroom design that would mirror your personality and offer you a sense of connection. From the colour palette and decor to bedroom tile designs and furniture, every detail plays an important role in creating a truly relaxing atmosphere. That's why, when you are planning a bedroom makeover, exploring different <strong>bedroom design ideas </strong>can help you create a look that matches your style. 
Within a bedroom design, the choice of tiles can set the foundation for the entire decor. We bring you bedroom tile options in ceramic and vitrified that are available in a variety of designs, sizes, and colours to cater to most preferences and bedroom interior decor. Complementing these tiles with well-chosen furniture, lighting, and decor will enhance the ambience of your bedroom and boost its functionality. By thoughtfully pairing these elements, you'll create a welcoming bedroom where you'll love spending time.
      `;
  const maxChars = 300;
  const previewText = text.substring(0, maxChars);
  const remainingText = text.substring(maxChars);

  const handleShow = (e) => {
    // Use event.target to get the image element
    const imgElement = e.target;
    if (imgElement && imgElement.src) {
      setSelectedImage(imgElement.src);
      setShow(true);
    }
  };
  const handleClose = () => {
    setSelectedImage(null);
    setShow(false);
  };

  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  var requestOptions = {
    method: "GET",
  };
  const getRelatedBlogs = async () => {
    // try{
    let blogQuery =
      router.asPath.split("/")[router.asPath.split("/").length - 1];

    fetch(
      `${config.HEADLESS_BASE_URL}/blog/wp-json/post/v2/category/term=${blogQuery}`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => {
        setRelatedBlogData(JSON.parse(result));
      })
      .catch((error) => console.log("error", error));
  };

  const scrollToElement = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const headerOffset = 100; // Adjust based on your header height
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition =
        elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };
  return (
    <>
      <Head>
        <title>Inspiring Bedroom Design Ideas | Orientbell Tiles</title>

        <meta
          name="title"
          content="Inspiring Bedroom Design Ideas | Orientbell Tiles"
        />
        <meta
          name="description"
          content="Transform your bedroom with inspiring bedroom design ideas. Explore modern, stylish bedroom interior designs at Orientbell to create your dream space
"
        />

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              itemListElement: [
                {
                  "@type": "ListItem",
                  position: 1,
                  name: "Home",
                  item: "https://www.orientbell.com/",
                },
                {
                  "@type": "ListItem",
                  position: 2,
                  name: "Design Ideas",
                  item: "https://www.orientbell.com/design-ideas/",
                },
                {
                  "@type": "ListItem",
                  position: 3,
                  name: "Bedroom Designs",
                  item: "https://www.orientbell.com/design-ideas/bedroom-designs",
                },
              ],
            }),
          }}
        ></script>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebPage",
              url: "design-ideas/bedroom-designs",
              headline: "",
              breadcrumb: "Home > Design Ideas > Bedroom Designs",
              name: "Inspiring Bedroom Design Ideas | Orientbell Tiles",
              description:
                "Transform your bedroom with inspiring bedroom design ideas. Explore modern stylish bedroom designs to create your dream space.Get expert consultation.",
            }),
          }}
        ></script>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: [
                {
                  "@type": "Question",
                  name: "How do I get the right bedroom layout for my space?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "For the right bedroom layout, consider your bedroom's dimensions and shape. Start by placing essential furniture, like the bed, in a central position. Ensure there’s ample space for movement and practical access to storage areas. Experiment with the placement of your furniture on the floor space to visualize and optimize the layout.",
                  },
                },
                {
                  "@type": "Question",
                  name: "What are some popular bedroom design styles?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Popular bedroom styles include the modern style that features clean lines, neutral shades of tiles, and simple decor. Then we have classics featuring elegant furniture and rich colours. There's also rustic, which comes with old wooden finish materials and grey or black tiles. And then there's coastal, which uses light colours, wooden tiles, and beach-inspired decor.",
                  },
                },
                {
                  "@type": "Question",
                  name: "What lighting options are best for bedrooms?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Use various lighting to light up different parts of your bedroom. You can go ahead with overhead lights or install a ceiling fan with light for general lighting. Besides that, bedside lamps, LED strips, or wall sconces can be used to add style and extra light.",
                  },
                },
                {
                  "@type": "Question",
                  name: "How do I choose the right colour scheme for my bedroom?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Colour schemes help establish the atmosphere you want in your bedroom. Shades like beige and grey help set the tone of relaxation, while bold ones like blue and green create a statement and vibrancy.",
                  },
                },

                {
                  "@type": "Question",
                  name: "What are the latest trends in bedroom design?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Bedroom designs in trend incorporate elements like plants and wooden furniture. Textured wall tiles for visual interest and multifunctional furniture to conserve space have also been popular. Additionally, warm-toned tiles for both walls and floors are also popular for a cosy and inviting look.",
                  },
                },
              ],
            }),
          }}
        ></script>
      </Head>
      <div class="designpage-section">
        <div class="container">
          <Breadcrumb>
            <Breadcrumb.Item href="https://www.orientbell.com">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item href="https://www.orientbell.com/design-ideas">
              Design Ideas
            </Breadcrumb.Item>
            <Breadcrumb.Item href="https://www.orientbell.com/design-ideas/bedroom-designs">
              Bedroom Designs
            </Breadcrumb.Item>
          </Breadcrumb>

          <div class="designpage-heading-bx padding-spacing">
            <h1>Bedroom Designs</h1>
            <p className="description-text">
              {previewText}
              {!isReadMore && text.length > maxChars && "..."}
              {isReadMore && <span>{remainingText}</span>}
              {text.length > maxChars && (
                <button onClick={toggleReadMore}>
                  {isReadMore ? "Read Less" : "Read More"}
                </button>
              )}
            </p>
          </div>
          <div class="desi-page-category-col-bx">
            <div class="design-category-head-row">
              <Slider {...settings2}>
                <div>
                  <a
                    href="#Modern-Bedroom-Design"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToElement("Modern-Bedroom-Design");
                    }}
                  >
                    Modern Bedroom Designs
                  </a>
                </div>
                <div>
                  <a
                    href="#Master-Bedroom-Design"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToElement("Master-Bedroom-Design");
                    }}
                  >
                    Master Bedroom Designs
                  </a>
                </div>
                <div>
                  <a
                    href="#Small-Bedroom-Design"
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToElement("Small-Bedroom-Design");
                    }}
                  >
                    Small Bedroom Designs
                  </a>
                </div>
                <div>
                  <a
                    href="#Simple-Bedroom-Design "
                    onClick={(e) => {
                      e.preventDefault();
                      scrollToElement("Simple-Bedroom-Design");
                    }}
                  >
                    Simple Bedroom Designs{" "}
                  </a>
                </div>

                {/* <div><a href="#Blue-Bathroom">Blue Bathroom Design</a></div> */}
              </Slider>
            </div>

            <div class="design-category-col-right">
              <div class="designpage-category-wrap" id="Modern-Bedroom-Design">
                <h3>Modern Bedroom Designs</h3>
                <div class="designpage-category-row padding-spacing">
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Bedroom_Design/Modern_Bedroom/GFT_BDF_Natural_Maple_Wood_Bedroom_Germfree+Forever_Tiles_Porcelain_Tile_600x600mm.jpg"
                        alt="GFT BDF Natural Maple Wood_Bedroom_Germfree+Forever Tiles_Porcelain Floor Tile_600x600 mm"
                      />
                    </div>
                    <div class="designpage-text">
                      <h4>
                        Spacious Modern Bedroom Design with Tufed bed and Tiled
                        Wall{" "}
                      </h4>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Bedroom_Design/Modern_Bedroom/DR_PGVT_Statuario_Vein_Marble_600x600mm.jpg"
                        alt="/DR PGVT Statuario Vein Marble_600x600 mm"
                      />
                    </div>
                    <div class="designpage-text">
                      <h4>
                        Contemporary style bedroom with modern furnishings
                      </h4>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Bedroom_Design/Modern_Bedroom/PCG_Crystal-Onyx_Bedroom_600x600mm.jpg"
                        alt="Modern small Bedroom Design"
                      />
                    </div>
                    <div class="designpage-text">
                      <h4>Modern small Bedroom Design with Classic Design</h4>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Bedroom_Design/Modern_Bedroom/PGVT-Armani-Marble-Grey-DK_600x600mm.jpg"
                        alt="ODM Batik Sandune, ODM Batik Crema & ODH Batik Leaf HL_Kitchen_30x60 CM"
                      />
                    </div>
                    <div class="designpage-text">
                      <h4>
                        Luxury Modern Bedroom Design with Marble Floor Design
                      </h4>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="designpage-category-wrap" id="Master-Bedroom-Design">
                <h3>Master Bedroom Designs</h3>
                <div class="designpage-category-row padding-spacing">
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Bedroom_Design/Master_Bedroom/CARVING_METAL_BRECCIA-MARBLE_600x1200mm.jpg"
                        alt="public/CARVING METAL BRECCIA MARBLE_600x1200 mm.jpg"
                      />
                    </div>
                    <div class="designpage-text">
                      <h4>
                        Contemporary Master Bedroom design with Beautiful wall &
                        Floor Combination
                      </h4>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Bedroom_Design/Master_Bedroom/Modern_contemporary_bedroom_Design_with_Brown_and_White_combination600x1200mm.jpg"
                        alt="bedroom Design with Brown and White colour"
                      />
                    </div>
                    <div class="designpage-text">
                      <h4>
                        Modern contemporary bedroom Design with Brown and White
                        combination
                      </h4>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Bedroom_Design/Master_Bedroom/DR_PGVT_Makrana_Bianco_600x600mm.jpg"
                        alt="bedroom design with white marble"
                      />
                    </div>
                    <div class="designpage-text">
                      <h4>
                        Master bedroom design with king size bed and white
                        marble combination
                      </h4>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>

                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Bedroom_Design/Master_Bedroom/GFT_FT_Bambo_Bedroom_Germfree+Forever_Tiles_Porcelain_Floor_Tile_600x600mm.jpg"
                        alt="Bedroom Design in Modern Style"
                      />
                    </div>
                    <div class="designpage-text">
                      <h4>
                        Master Bedroom Design in Modern Style with open space
                      </h4>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Bedroom_Design/Master_Bedroom/NATURAL-ROTTOWOOD-BEIGE_600x1200mm.jpg"
                        alt="Bedroom Design with Wooden Floor"
                      />
                    </div>
                    <div class="designpage-text">
                      <h4>
                        Contemporary Master Bedroom Design with Wooden Floor &
                        Walls
                      </h4>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="designpage-category-wrap" id="Small-Bedroom-Design">
                <h3>Small Bedroom Designs</h3>
                <div class="designpage-category-row padding-spacing">
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Bedroom_Design/Small_Bedroom/Carving_Decor_Autumn_Multi_Leaf&DGVT_Coquina_Sand-Ivory_600x1200mm.jpg"
                        alt="bedroom design with brown bed"
                      />
                    </div>
                    <div class="designpage-text">
                      <h4>
                        Small bedroom design with brown bed and printed Wall
                      </h4>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Bedroom_Design/Small_Bedroom/CARVING_METAL_BRECCIA_MARBLE_600x1200mm.jpg"
                        alt="Bedroom design with Beautiful wall & Floor"
                      />
                    </div>
                    <div class="designpage-text">
                      <h4>
                        Contemporary Master Bedroom design with Beautiful wall &
                        Floor Combination
                      </h4>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>

                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Bedroom_Design/Small_Bedroom/Emboss_Gloss_Crackle_Marble_Grey&DGVT_Coquina_Sand_Grey_LT_600x1200mm.jpg"
                        alt="Small bedroom design with grey wall"
                      />
                    </div>
                    <div class="designpage-text">
                      <h4>
                        {" "}
                        Small bedroom design with modern look with Grey wall{" "}
                      </h4>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>

                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Bedroom_Design/Small_Bedroom/PGVT_Fog_Onyx_Beige_Bedroom_Glazed_Vitrified_Tiles_Wall&Floor-Tile_600x1200mm.jpg"
                        alt="Small Bedroom Design With Creme colour"
                      />
                    </div>
                    <div class="designpage-text">
                      <h4>
                        {" "}
                        Simple & Small Bedroom Design With Creme colour
                        combination{" "}
                      </h4>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="designpage-category-wrap" id="Simple-Bedroom-Design ">
                <h3>Bedroom Designs </h3>
                <div class="designpage-category-row padding-spacing">
                  <div class="designpage-category-col">
                    <div class="designpage-figure">
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Bedroom_Design/GFT_BDF_Royal_Dyna_Grey FT_ 600x600mm.jpg"
                        alt="GFT BDF Royal Dyna Grey FT_ 600x600 mm"
                      />
                    </div>
                    <div class="designpage-text">
                      <h4>
                        Simple Master Bedroom design with grey and white
                        combination
                      </h4>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Bedroom_Design/PGVT_Pulpis_Marble-Grey_Bedroom_Glazed600x1200mm.jpg"
                        alt="/DR PGVT Elegant Marble Gold Vein_600x1200 mm.jpg"
                      />
                    </div>
                    <div class="designpage-text">
                      <h4>
                        Simple bedroom design with king-size bed and marble
                        floor and wall design
                      </h4>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://images.orientbell.com/media/Oblimage/Bedroom_Design/SHM_TRIANGLE_CHARCOAL_DK&SBM_STUCCO_CHARCOAL_LT_300x450mm.jpg"
                        alt="SHM TRIANGLE CHARCOAL HL, SBM STUCCO CHARCOAL DK & SBM STUCCO CHARCOAL LT_300x450mm-min"
                      />
                    </div>
                    <div class="designpage-text">
                      <h4>
                        Simple Bedroom design with small bed and leaf patterned
                        wall
                      </h4>
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>

                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://server.orientbell.com/media/Bedrroom/ODG%20Brown%20Star%20Petal%20&%20ODG%20Creama%20Star%20Petal_300x450mm.webp"
                        alt="SHM TRIANGLE CHARCOAL HL, SBM STUCCO CHARCOAL DK & SBM STUCCO CHARCOAL LT_300x450mm-min"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h4>Simple Bedroom design with small bed and leaf patterned wall</h4> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>

                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://server.orientbell.com/media/Bedrroom/OHG%20Aqua%20Palm%20Daisy%20Flower%20HL,%20ODG%20Aqua%20LT%20Exotic%20Palm%20Leaf%20&%20ODG%20Aqua%20DK%20Exotic%20Palm%20Leaf_300x450mm.webp"
                        alt="SHM TRIANGLE CHARCOAL HL, SBM STUCCO CHARCOAL DK & SBM STUCCO CHARCOAL LT_300x450mm-min"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h4>Simple Bedroom design with small bed and leaf patterned wall</h4> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>

                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="https://server.orientbell.com/media/Bedrroom/OHG%20Beige%20Petals%20Sand%20HL,%20ODG%20Brown%20Petals%20Sand%20&%20ODG%20Beige%20Petals%20Sand_300x450mm.webp"
                        alt="SHM TRIANGLE CHARCOAL HL, SBM STUCCO CHARCOAL DK & SBM STUCCO CHARCOAL LT_300x450mm-min"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h4>Simple Bedroom design with small bed and leaf patterned wall</h4> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>

                  <div class="designpage-category-col">
                    <div class="designpage-figure" onClick={handleShow}>
                      <img
                        src="                        https://server.orientbell.com/media/Bedrroom/OHG%20Mulberry%20Leaf%20Strips%20HL,%20ODG%20Pink%20LT%20Strips%20&%20ODG%20Pink%20DK%20Strips_300x450mm.webp
"
                        alt="SHM TRIANGLE CHARCOAL HL, SBM STUCCO CHARCOAL DK & SBM STUCCO CHARCOAL LT_300x450mm-min"
                      />
                    </div>
                    <div class="designpage-text">
                      {/* <h4>Simple Bedroom design with small bed and leaf patterned wall</h4> */}
                      <button
                        class="talk-expert-btn talk-to-expert-design-page"
                        onClick={() => {
                          setIsExpertTalkClicked(true);
                        }}
                      >
                        Talk to Expert
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="YouTube-video-row">
            <iframe
              width="560"
              height="450"
              style={{
                // aspectRatio: 3 / 1 /* or whatever ratio you need */,
                border: 0,
              }}
              src="https://www.youtube.com/embed/iXgBHFS6GCo?si=thhceZAHbGaAGEh1"
              title="YouTube video player"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            />
          </div>

          <div class="designpage-detail-text padding-spacing">
            <h2>Functional & Stylish Bedroom Design Ideas</h2>
            <p>
              You have to pick the right elements to make your bedroom both
              stylish and practical. Below are some of the pointers for a{" "}
              <strong>stylish bedroom </strong>that will help you improve your
              bedroom’s look while keeping it all functional:
            </p>
            <ul>
              <li>
                <h5>
                  <strong>Start with a Colour Scheme:</strong>
                </h5>
                <p>
                  Plan Colour schemes in soft neutrals like beige or cream for a
                  calming effect; however, use bold with browns and charcoal
                  greys for a more dramatic look. The right choice of colour
                  scheme you go with always sets the foundational tone for your
                  bedroom.
                </p>{" "}
              </li>
              <li>
                <h5>
                  <strong>Add the Bed:</strong>
                </h5>
                <p>
                  Plan Colour schemes in soft neutrals like beige or cream for a
                  calming effect; however, use bold with browns and charcoal
                  greys for a more dramatic look. The right choice of colour
                  scheme you go with always sets the foundational tone for your
                  bedroom.
                </p>{" "}
              </li>
              <li>
                <h5>
                  <strong>Go for Multi-Functional Furniture:</strong>
                </h5>
                <p>
                  Find built-in wardrobes and beds with storage underneath to
                  keep your bedroom tidy. Always choose multi-functional
                  furniture like tall open shelves or side tables that can
                  double as storage.{" "}
                </p>{" "}
              </li>
              <li>
                <h5>
                  <strong>Choose Bedroom Tiles Wisely:</strong>
                </h5>
                <p>
                  With so many designs and finishes, selecting the right tiles
                  is crucial for a stylish and functional bedroom. When choosing{" "}
                  <strong>bedroom wall tile designs</strong>, marble or
                  geometric tiles in glossy finish can offer a polished look.
                  You can also explore our touch-and-feel tiles. They bring
                  tactile elements that add texture and luxury. For the floors,
                  you can opt for wood-like tiles in a matte finish. They
                  provide a better grip and beautifully complement the glossy
                  walls.{" "}
                </p>{" "}
              </li>
              <li>
                <h5>
                  <strong>Make Use of Lighting:</strong>
                </h5>
                <p>
                  Lighting can set the ultimate vibe of your bedroom. Get
                  different types of lights, like ambient lighting from ceiling
                  fixtures, accent lighting such as pendant lights around the
                  bed or table lamps at the bedside table. This mix creates a
                  cosy atmosphere.
                </p>{" "}
              </li>

              <li>
                <h5>
                  <strong>Add Elements to Enhance Comfort: </strong>
                </h5>
                <p>
                  Include a hanging or rocking chair to bring a touch of
                  elegance and create a spot to relax. Choose a statement
                  headboard with rich textures or bold colours to make it the
                  focal point of your modern bedroom design, enhancing both
                  style and comfort.
                </p>
              </li>

              <li>
                <h5>
                  <strong>Get a Walk-In Wardrobe: </strong>
                </h5>
                <p>
                  Building a walk-in wardrobe can combine practicality with
                  luxury. It will provide ample space for your clothes and
                  accessories. You can use a glass partition to separate the
                  wardrobe area from the bedroom, keeping the space open and
                  elegant.
                </p>
              </li>

              <li>
                <h5>
                  <strong>Use Beautiful Décor Pieces:</strong>
                </h5>
                <p>
                  Your luxury bedroom decor can use some decorating pieces in
                  the form of flower vases, tall standing lamps, or indoor
                  plants to add warmth and style. You can also install photo
                  frames or create an accent wall to enhance the room's
                  elegance.
                </p>
              </li>
            </ul>
          </div>

          <div class="designpage-detail-text padding-spacing">
            <h2>Small Bedroom Designs</h2>
            <p>
              For a small bedroom design to be effective, take up the following
              smart bedroom ideas and make the most of your room while not
              compromising on the style and usability aspect:
            </p>
            <ul>
              <li>
                <h5>
                  <strong>Be Mindful of Colours: </strong>
                </h5>
                <p>
                  Light shades help open up your bedroom space while being
                  calming in nature. Go for colours like white or soft grey to
                  make the room look spacious.
                </p>
              </li>
              <li>
                <h5>
                  <strong>Choose Large-Size Tiles:</strong>
                </h5>
                <p>
                  Larger floor tiles in sizes like 1200x1800 mm or 800x1600 mm
                  can be an ideal option as they reduce visual clutter. They are
                  known to minimise grout lines, creating a seamless look and
                  making your bedroom appear more spacious. For{" "}
                  <strong>wall tiles for the bedroom</strong>, go for tiles in a
                  neutral shade and glossy finish.{" "}
                </p>
              </li>
              <li>
                <h5>
                  <strong>Make Use of Glass Partitions:</strong>
                </h5>
                <p>
                  If you want to create a bedroom setting that has an open
                  layout, glass partitions can help. They can define areas
                  without making the room feel cramped and allow light to flow
                  through, maintaining an open and airy feel.
                </p>
              </li>
              <li>
                <h5>
                  <strong>Make Most of Vertical Space:</strong>
                </h5>
                <p>
                  In small bedroom designs, using up the vertical space can be a
                  smart move. Get some shelves or open storage units that go up
                  to the ceiling. They will maximise storage without taking up
                  too much floor space.
                </p>
              </li>
              <li>
                <h5>
                  <strong>Play with Lighting and Mirrors:</strong>
                </h5>
                <p>
                  {" "}
                  Proper lighting and mirrors will make the room feel bigger and
                  brighter. Wall lights or hanging lights save space while
                  giving enough light. A mirror can reflect light and make the
                  room look more spacious.{" "}
                </p>
              </li>
            </ul>
          </div>
          <div class="designpage-detail-text padding-spacing">
            <h2>Explore Colour Ideas for Your Bedroom Design</h2>
            <p>
              The right colours can significantly impact the atmosphere and
              style of your bedroom. Following are some of the{" "}
              <strong>bedroom design colour</strong> options that you can
              consider:
            </p>

            <ul>
              <li>
                <h5>
                  <strong>Functionality</strong>
                </h5>
                <p>
                  The perfect bathroom design skillfully combines form and
                  function, making sure that each element fulfils a functional
                  need while boosting the space's overall visual attractiveness.
                </p>
              </li>
              <li>
                <h5>
                  <strong>Optimal Design</strong>
                </h5>
                <p>
                  A carefully planned design makes the most of the available
                  space and promotes easy mobility within the bathroom. The
                  arrangement of fixtures and storage options improves comfort
                  and convenience.
                </p>
              </li>
              <li>
                <h5>
                  <strong>Luxurious Materials</strong>
                </h5>
                <p>
                  Select high-quality materials for your bathroom interiors
                  design that provides an air of refinement and elegance.
                  Whether you choose marble countertops or elegant tiles, the
                  right material will add grandeur and improve the mood.
                </p>
              </li>
              <li>
                <h5>
                  <strong>Sufficient Storage</strong>
                </h5>
                <p>
                  Having enough storage is crucial to keeping an area clear of
                  clutter. To keep necessities accessible and organised,
                  incorporate creative storage options like built-in cabinets,
                  floating shelves, or vanity units.
                </p>
              </li>
              <li>
                <h5>
                  <strong>Ambient Lighting</strong>
                </h5>
                <p>
                  Setting the tone and improving the spaces usefulness both
                  depend heavily on the lighting in the area. Use ambient, task,
                  and accent lighting in concert to make the space seem cosy and
                  to ensure there is enough light for different kinds of work.
                </p>
              </li>
            </ul>
          </div>
          <div class="designpage-detail-text padding-spacing">
            <h2>Explore Colour Ideas for Your Bedroom Design</h2>
            <p>
              The right colours can significantly impact the atmosphere and
              style of your bedroom. Following are some of the{" "}
              <strong>bedroom design colour </strong>options that you can
              consider:
            </p>

            <ul>
              <li>
                <h5>
                  <strong>Soft Neutrals</strong>
                </h5>
                <p>
                  With their calming effect, shades like beige, cream, and soft
                  grey make the room feel more spacious. Complement them with{" "}
                  <strong>simple bedroom wall tile designs </strong>in neutral
                  tones, choosing a glossy finish for the walls and a matte
                  finish for the floor. Add decor like light wood furniture to
                  complete the look. You can also pair soft neutrals with an
                  accent wall in blues or greens for added depth.
                </p>
              </li>
              <li>
                <h5>
                  <strong>Bold and Vibrant</strong>
                </h5>
                <p>
                  Opt for energetic colours like dark blue and black, to create
                  striking and dynamic bedrooms. Use marble wall tiles to
                  coordinate with bold colours, and wooden floor tiles for an
                  integrated look. Balance the vibrancy with simple decor or add
                  contrasting metallic accents to keep your bedroom design from
                  feeling too intense.
                </p>
              </li>
              <li>
                <h5>
                  <strong>Warm Earth Tones</strong>
                </h5>
                <p>
                  Colours like terracotta, warm brown, and green bring a cosy
                  and inviting feel. Choose tiles in white or with earthy tones
                  and match them with wooden decor and plants. Playing with
                  various colour combinations within this colour family will
                  offer a sense of warmth to your bedroom.{" "}
                </p>
              </li>
              <li>
                <h5>
                  <strong>Monochromes</strong>
                </h5>
                <p>
                  Create a modern look by using varying shades of a single
                  colour, like all greys or all blues. They will add character
                  without overwhelming your bedroom. You can match geometric
                  tiles with decor in similar tones to achieve a cohesive and
                  stylish design.
                </p>{" "}
              </li>
            </ul>
          </div>
          <div class="designpage-detail-text padding-spacing">
            <h2>Design Your Bedroom Interiors Based on Themes</h2>
            <p>
              {" "}
              <strong>Bedroom interior themes </strong> are known to create a
              unified look, making the space feel more personal and complete.
              Here are some of the themes you might like:
            </p>
            <ul>
              <li>
                <h5>
                  <strong>Modern</strong>
                </h5>
                <p>
                  Go for a clean and simple bedroom interior design with neutral
                  colours like white and grey. Use glossy marble tiles with
                  striking vein designs for the walls and matte finish tiles for
                  the floors. Decorate with simple furniture, geometric
                  patterns, and metallic accents to keep it stylish.
                </p>
              </li>
              <li>
                <h5>
                  <strong>Classic</strong>
                </h5>
                <p>
                  Create a timeless and elegant interior design style with
                  traditional furniture and warm colours. Choose tiles with
                  subtle patterns for the walls and warm, neutral floor tiles.
                  Add decor like mirrors and rich fabrics to complete the look.
                </p>
              </li>
              <li>
                <h5>
                  <strong>Rustic</strong>
                </h5>
                <p>
                  To create a cosy, country feel, you can make use of natural
                  materials and earthy colours. Pick bedroom floor tile designs
                  that look like wood or stone and go with warm textured tiles
                  for the walls. Decorate with metal furniture and vintage
                  accessories like drawer handles to add charm.
                </p>
              </li>
              <li>
                <h5>
                  <strong>Coastal</strong>
                </h5>
                <p>
                  Get a relaxed, beach-like vibe with light colour interiors.
                  Use blue or beige tiles for the walls and white tiles for the
                  floors. Add decor elements with wooden furniture and breezy
                  curtains to capture the coastal feel.
                </p>
              </li>
              <li>
                <h5>
                  <strong>Kids Bedroom</strong>
                </h5>
                <p>
                  Go with a playful and vibrant theme. The best tile options for
                  these bedroom walls will include fun patterns or bright shades
                  like blue, yellow, or pink. Alongside this, make use of
                  accessories like cartoon characters, soft toys, and creative
                  storage solutions to create a fun, lively, and functional
                  space for your child.
                </p>
              </li>
            </ul>
          </div>
          <div class="designpage-detail-text padding-spacing">
            <h2>Guide to Choose Perfect Bedroom Design</h2>
            <p>
              <strong>A perfect bedroom design </strong>involves various
              elements to build a room that aligns with your style and meets
              your needs. Below are the pointers for you to check through during
              the process:
            </p>
            <ul>
              <li>
                <h5>
                  <strong>Define Your Design Preference</strong>
                </h5>
                <p>
                  Start by selecting a style that resonates with you—whether
                  modern, classic, rustic, or coastal. This will guide your
                  choices for furniture, colours, and decor.
                </p>
              </li>
              <li>
                <h5>
                  <strong>Select Color Schemes Wisely</strong>
                </h5>
                <p>
                  Choose colours that enhance the mood of the room. Soft
                  neutrals can create a calming atmosphere, while bold colours
                  can add energy. Consider how the colour of your tiles will
                  complement your chosen palette.
                </p>
              </li>
              <li>
                <h5>
                  <strong>Choose the Right Tiles</strong>
                </h5>
                <p>
                  Tiles can make or break the entire look of your bedroom. Go
                  ahead and install large-format tiles that are ideal for a
                  contemporary aesthetic. Within finishes, glossy tiles are
                  recommended to enhance the walls, while matte tiles are great
                  for floors, balancing style and practicality. You can discover
                  diverse <strong>modern bedroom tile designs </strong>under one
                  roof at Orientbell Tiles.
                </p>
              </li>
              <li>
                <h5>
                  <strong>Consider Space Utilisation</strong>
                </h5>
                <p>
                  To achieve a perfect bedroom design, you have to make the most
                  of your room's dimensions by including multifunctional
                  furniture and clever storage solutions. This helps maintain an
                  uncluttered and efficient space.
                </p>
              </li>
              <li>
                <h5>
                  <strong>Incorporate Lighting</strong>
                </h5>
                <p>
                  Combine different types of lighting. Use multiple overhead
                  lights for general brightness, standing or table lamps for
                  tasks, and wall sconces to create well-lit-up areas.
                </p>
              </li>
              <li>
                <h5>
                  <strong>Add Personal Touches</strong>
                </h5>
                <p>
                  Personalising your bedroom will reflect your personality. Get
                  bedroom decoration items such as artwork, showpieces, and
                  accessories to express your style. Have items like decorative
                  cushions, rugs, or framed photos to make the space uniquely
                  yours.
                </p>
              </li>
              <li>
                <h5>
                  <strong>Ensure Comfort</strong>
                </h5>
                <p>
                  Focus on comfort by making some practical choices. For
                  example, you can install adjustable blinds or go for layered
                  curtains that will allow you to control natural light and
                  privacy, creating a cosy and functional environment as per
                  your needs and design preference.
                </p>
              </li>
            </ul>
          </div>

          <div className="designpage-faq-section padding-spacing">
            <h2>FAQs About Bedroom Design</h2>
            <div className="newacd designpage-faq-row">
              <ul className="accordion">
                {faqs.map((faq, index) => (
                  <li key={index}>
                    <a className="toggle" onClick={() => handleToggle(index)}>
                      {index + 1}. {faq.question}
                    </a>
                    {activeIndex === index && (
                      <ul className="inner">
                        <li>{faq.answer}</li>
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          {relatedBlogData?.length > 0 && (
            <div className="tile-related-blog">
              <h2 className="title">Related Blogs</h2>
              <div className="designpage-relatedpost-row">
                <Slider {...settings}>
                  {relatedBlogData?.map((obj, index) => {
                    return (
                      <div className="related-blog-col" key={index}>
                        <div className="blog-figure">
                          <a href={obj.permalink}>
                            <img
                              src={obj.image}
                              loading="lazy"
                              alt="Marble Tiles Vs Marble Slab: What is Better for Your Home?"
                            />
                          </a>
                        </div>
                        <div className="blog-text">
                          <div className="listingDate">{obj.date}</div>
                          <div className="listingHead">
                            <a href={obj.permalink}>
                              <div
                                dangerouslySetInnerHTML={{ __html: obj.title }}
                              />
                            </a>
                          </div>
                          <div className="listingText">
                            <p>
                              {" "}
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: obj.content.slice(0, -11),
                                }}
                              />
                            </p>
                            <div className="listingButton">
                              <a href={obj.permalink}>Read More</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </Slider>
              </div>
            </div>
          )}
        </div>
      </div>
      <Modal
        className="image-zoom-view-modal"
        show={show}
        autoFocus
        onHide={handleClose}
      >
        <Modal.Dialog>
          <Modal.Header closeButton />

          {selectedImage && <img height="400px" src={`${selectedImage}`}></img>}
        </Modal.Dialog>
      </Modal>

      <Modal
        show={isExpertTalkClicked}
        className="pincode-popup-bx expert_assistance_modal ask-question-popup"
        onHide={() => {
          // setTimePopup(false)
          // setGetInTouch(false)
          setIsExpertTalkClicked(false);
          // localStorage.setItem('leadSkiped',true)
        }}
      >
        <Modal.Dialog>
          <Modal.Header closeButton>
            <Modal.Title>Get in touch with our tile expert</Modal.Title>
          </Modal.Header>
          <div className="ask-question-section">
            <div className="expert-fig-bx">
              <img src="/new-tareek.jpg" />
            </div>
            <Modal.Body>
              <h2>Ask Tile Expert</h2>
              <p>Let Experts Help You In Buying Process</p>
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  submitGetInTouch();
                }}
              >
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e) => {
                      setTouch({
                        ...touch,
                        name: e.target.value,
                      });
                    }}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Mobile</Form.Label>

                  <Form.Control
                    type="number"
                    onChange={(e) => {
                      setTouch({
                        ...touch,
                        number: `${touch.countryCode || ""}${e.target.value}`, // Append the country code
                      });
                    }}
                  />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Pincode</Form.Label>
                  <Form.Control
                    type="number"
                    value={touch.pincode}
                    onChange={(e) => {
                      setTouch({
                        ...touch,
                        pincode: e.target.value,
                      });
                    }}
                  />
                </Form.Group>

                {touch.error && (
                  <p className="error text-danger">{touch.error}</p>
                )}

                <Button
                  variant="primary"
                  type="submit"
                  disabled={touch.loading}
                  style={{ width: "100%" }}
                >
                  {touch.loading ? "Submitting" : "Submit"}
                </Button>
              </Form>
            </Modal.Body>
          </div>
          {/* <Modal.Footer>
              <Button variant="primary" onClick={() => handlePinSave()}>
                Submit
              </Button>
            </Modal.Footer> */}
        </Modal.Dialog>
      </Modal>
    </>
  );
}

export default BedroomDesigns;
